/* モフトレチェック/月選択画面 */
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as AuthActions from '../actions/Auth';
import * as MoffAPIActions from '../actions/MoffAPI';
import * as MoffCheckActions from '../actions/MoffCheck';
import * as HeaderActions from '../actions/Header';
import MoffCheckSelectMonth from '../components/MoffCheckSelectMonth';

const mapStateToProps = (state: any) => {
  return {
    // configureStore
    auth: state.auth,
    moffAPI: state.moffAPI,
    moffCheck: state.moffCheck,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    authActions: bindActionCreators(AuthActions, dispatch),
    moffAPIActions: bindActionCreators(MoffAPIActions, dispatch),
    moffCheckActions: bindActionCreators(MoffCheckActions, dispatch),
    headerActions: bindActionCreators(HeaderActions, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MoffCheckSelectMonth as any);



// WEBPACK FOOTER //
// ./src/containers/MoffCheckSelectMonth.tsx